import { type ProductizedServiceSidebar_productizedService$key } from '#app/__generated__/relay/ProductizedServiceSidebar_productizedService.graphql.js';
import { ProductizedServiceCTAs } from './components/ProductizedServiceCTAs/ProductizedServiceCTAs.js';
import { ProductizedServiceDetails } from './components/ProductizedServiceDetails/ProductizedServiceDetails.js';
import { ProductizedServiceIndustries } from './components/ProductizedServiceIndustries/ProductizedServiceIndustries.js';
import { ProductizedServicePrice } from './components/ProductizedServicePrice/ProductizedServicePrice.js';
import { ProductizedServiceSkillsTools } from './components/ProductizedServiceSkillsTools/ProductizedServiceSkillsTools.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  ${({ theme }) => `
    position: sticky;
    top: 88px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 32px 24px 32px 24px;
    background-color: ${theme.colorsV2.white};
    border: 1px solid ${theme.colorsV2.gray30};
    border-radius: 12px;
  `}
`;

const ThematicBreak = styled.div`
  ${({ theme }) => `
    height: 0px;
    border-top: 1px solid ${theme.colorsV2.gray30};
  `}
`;

type ProductizedServiceSidebarProps = {
  readonly productizedServiceRef: ProductizedServiceSidebar_productizedService$key;
};

export const ProductizedServiceSidebar = ({
  productizedServiceRef,
}: ProductizedServiceSidebarProps) => {
  const service = useFragment<ProductizedServiceSidebar_productizedService$key>(
    graphql`
      fragment ProductizedServiceSidebar_productizedService on ProductizedService {
        ...ProductizedServicePrice_productizedService
        ...ProductizedServiceDetails_productizedService
        ...ProductizedServiceSkillsTools_productizedService
        ...ProductizedServiceCTAs_productizedService
        ...ProductizedServiceIndustries_productizedService
      }
    `,
    productizedServiceRef,
  );

  return (
    <Container aria-label="service sidebar">
      <ProductizedServicePrice productizedServiceRef={service} />
      <ProductizedServiceCTAs productizedServiceRef={service} />
      <ThematicBreak />
      <ProductizedServiceDetails productizedServiceRef={service} />
      <ProductizedServiceSkillsTools productizedServiceRef={service} />
      <ProductizedServiceIndustries productizedServiceRef={service} />
    </Container>
  );
};
